import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from "src/environments/environment";
import { Culture, EspeceCulture } from '../../models/culture.model';

@Injectable({ providedIn: 'root' })
export class CultureService {

    constructor(private http: HttpClient) { }

    BASE = 'cultures';


    getAll() {

        return this.http.get<Culture[]>(environment.BASE_URL + `/api/${this.BASE}`);
    }


    add(culture: any) {
        return this.http.post<Culture>(environment.BASE_URL + `/api/${this.BASE}`, culture);
    }

    update(id: number, culture: any) {
        return this.http.put<Culture>(environment.BASE_URL + `/api/${this.BASE}/${id}`, culture);
    }

    delete(id: number) {
        return this.http.delete<void>(environment.BASE_URL + `/api/${this.BASE}/${id}`);
    }

    /** Cultures (espèces) et leurs campagnes, triées par dernière plantation */
    especes() {
        return this.http.get<EspeceCulture[]>(environment.BASE_URL + `/api/${this.BASE}/especes`);
    }

    getById(id: number) {
        return this.http.get<Culture>(environment.BASE_URL + `/api/${this.BASE}/${id}`);
    }

    findByType(type) {
        return this.http.get<Culture[]>(environment.BASE_URL + `/api/${this.BASE}/type/${type}`);
    }

    // Sprint 1 — J9: enregistrer la récolte
    enregistrerRecolte(id: number, dateRecolteReelle?: string) {
        let url = environment.BASE_URL + `/api/${this.BASE}/${id}/recolte`;
        if (dateRecolteReelle) url += `?dateRecolteReelle=${dateRecolteReelle}`;
        return this.http.patch<Culture>(url, {});
    }

    /** Statut seul (actions groupées) */
    changerStatut(id: number, statut: string) {
        return this.http.patch<Culture>(environment.BASE_URL + `/api/${this.BASE}/${id}/statut?statut=${statut}`, {});
    }
}
